import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const EventManagementCard = ({ event, detailed = false }) => {
  const isFull = event.participants >= event.maxParticipants;
  const fillPercentage = (event.participants / event.maxParticipants) * 100;

  const getStatusBadge = () => {
    switch (event.status) {
      case 'active':
        return <span className="px-2 py-1 text-xs font-medium rounded-full bg-success/10 text-success">진행중</span>;
      case 'full':
        return <span className="px-2 py-1 text-xs font-medium rounded-full bg-warning/10 text-warning">모집완료</span>;
      case 'ended':
        return <span className="px-2 py-1 text-xs font-medium rounded-full bg-muted text-muted-foreground">종료</span>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-base font-semibold text-foreground">{event.title}</h3>
            {getStatusBadge()}
          </div>
          <p className="text-sm text-muted-foreground caption">{event.sportType}</p>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="CalendarIcon" size={16} className="text-muted-foreground" />
          <span>
            {event.date} {event.time}
          </span>
        </div>
        {detailed && (
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="MapPinIcon" size={16} className="text-muted-foreground" />
            <span>{event.location}</span>
          </div>
        )}
        <div className="space-y-1">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2">
              <Icon name="UserGroupIcon" size={16} className="text-muted-foreground" />
              <span className="text-foreground">
                {event.participants}/{event.maxParticipants}명
              </span>
            </div>
            <span className="text-xs text-muted-foreground">{fillPercentage.toFixed(0)}%</span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className={`h-full transition-smooth ${isFull ? 'bg-warning' : 'bg-primary'}`}
              style={{ width: `${fillPercentage}%` }}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          className="flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-border text-foreground hover:bg-muted transition-smooth touch-target text-sm font-medium"
          type="button"
        >
          <Icon name="PencilIcon" size={16} />
          <span>편집</span>
        </button>
        <button
          className="flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-border text-foreground hover:bg-muted transition-smooth touch-target text-sm font-medium"
          type="button"
        >
          <Icon name="UsersIcon" size={16} />
          <span>참가자</span>
        </button>
        {detailed && (
          <button
            className="flex items-center justify-center px-3 py-2 rounded-lg border border-border text-foreground hover:bg-muted transition-smooth touch-target"
            type="button"
          >
            <Icon name="EllipsisVerticalIcon" size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default EventManagementCard;
